var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewTask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11.5C2 7.90926 4.90926 5 8.5 5C9.38598 5 10.2305 5.17712 11 5.49788V4.42655C10.2181 4.1503 9.37665 4 8.5 4C4.35697 4 1 7.35697 1 11.5C1 15.643 4.35697 19 8.5 19C12.643 19 16 15.643 16 11.5C16 10.6234 15.8497 9.7819 15.5735 9H14.5021C14.8229 9.76953 15 10.614 15 11.5C15 15.0907 12.0907 18 8.5 18C4.90926 18 2 15.0907 2 11.5Z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.57398L11.406 9L7.19383 13.0083L5.60077 11.5032L5 12.0708L6.89007 13.8565C6.97445 13.9362 7.0892 14 7.19045 14C7.29171 14 7.40309 13.9362 7.48746 13.8597L12 9.57398Z",
    fill: "#4F4F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 2H14.5V4.5H12V5.5H14.5V8H15.5V5.5H18V4.5H15.5V2Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTask);
export default __webpack_public_path__ + "static/media/new-task.90d37fd997edba4d1920d57423c29ca8.svg";
export { ForwardRef as ReactComponent };